// components/ImageCropper.js
import React, { useState, useRef } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

const ImageCropper = ({ image, onCropComplete, aspectRatio = 16/9 }) => {
  const [crop, setCrop] = useState({
    unit: '%',
    width: 90,
    aspect: aspectRatio
  });
  const [completedCrop, setCompletedCrop] = useState(null);
  const imageRef = useRef(null);

  const handleCropComplete = (crop) => {
    setCompletedCrop(crop);
  };

  const getCroppedImg = () => {
    if (!imageRef.current || !completedCrop) return;

    const image = imageRef.current;
    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    
    canvas.width = completedCrop.width * scaleX;
    canvas.height = completedCrop.height * scaleY;
    
    const ctx = canvas.getContext('2d');
    
    ctx.drawImage(
      image,
      completedCrop.x * scaleX,
      completedCrop.y * scaleY,
      completedCrop.width * scaleX,
      completedCrop.height * scaleY,
      0,
      0,
      completedCrop.width * scaleX,
      completedCrop.height * scaleY
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        resolve(blob);
      }, 'image/jpeg', 0.95);
    });
  };

  const handleCrop = async () => {
    const croppedImage = await getCroppedImg();
    if (croppedImage) {
      onCropComplete(croppedImage);
    }
  };

  return (
    <div className="image-cropper-modal">
      <div className="cropper-container">
        <ReactCrop
          crop={crop}
          onChange={(newCrop) => setCrop(newCrop)}
          onComplete={handleCropComplete}
          aspect={aspectRatio}
          className="image-cropper"
        >
          <img
            ref={imageRef}
            src={image}
            alt="Crop preview"
            style={{ maxWidth: '100%' }}
          />
        </ReactCrop>
        
        <div className="crop-controls">
          <button 
            type="button" 
            onClick={handleCrop}
            className="crop-btn"
          >
            Valider le rognage
          </button>
          <button 
            type="button" 
            onClick={() => onCropComplete(null)}
            className="cancel-crop-btn"
          >
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageCropper;